/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { DesktopView, MobileView } from './shared';
import useInView from './useInView';
import * as styles from './whatsNew.module.scss';

const assertBaseUrl = process.env.REACT_APP_ASSETS_BASE_URL;

const WhatsNew = () => {
  const [animatePhone1, doAnimatePhone1] = useState(false);
  const [animatePhone2, doAnimatePhone2] = useState(false);
  const [animatePhone3, doAnimatePhone3] = useState(false);
  const phone1InViewState = useInView({ threshold: 0.2, triggerOnce: true });
  const phone2InViewState = useInView({ threshold: 0.2, triggerOnce: true });
  const phone3InViewState = useInView({ threshold: 0.2, triggerOnce: true });
  const whatsNewInViewState = useInView({ threshold: 0.2, triggerOnce: true });
  const windowWidth = window.innerWidth;
  const isMobile = windowWidth <= 768;
  const isDesktop = windowWidth >= 769;

  useEffect(() => {
    const phoneAnimate = () => {
      !animatePhone1 && doAnimatePhone1(true);
      !animatePhone2 &&
        setTimeout(() => {
          // add .animate to each after 200ms
          doAnimatePhone2(true);
        }, 250);
      !animatePhone3 &&
        setTimeout(() => {
          // add .animate to each after 200ms
          doAnimatePhone3(true);
        }, 500);
    };
    if (isDesktop && whatsNewInViewState.inView) {
      phoneAnimate();
    }
  }, [windowWidth, whatsNewInViewState.inView]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--blob-image',
      `url('${assertBaseUrl}/images/blobs.png')`,
    );
    document.documentElement.style.setProperty(
      '--blob-image2',
      `url('${assertBaseUrl}/images/blobs2.png')`,
    );
  }, [assertBaseUrl]);

  const phone1AnimateBool = (phone1InViewState.inView && isMobile) || animatePhone1;
  const phone2AnimateBool = (phone2InViewState.inView && isMobile) || animatePhone2;
  const phone3AnimateBool = (phone3InViewState.inView && isMobile) || animatePhone3;

  return (
    <div className={styles.container} ref={whatsNewInViewState.ref}>
      {isMobile ? (
        <MobileView
          phone1Ref={phone1InViewState.ref}
          phone2Ref={phone2InViewState.ref}
          phone3Ref={phone3InViewState.ref}
          phone1AnimateBool={phone1AnimateBool}
          phone2AnimateBool={phone2AnimateBool}
          phone3AnimateBool={phone3AnimateBool}
        />
      ) : (
        <DesktopView
          phone1Ref={phone1InViewState.ref}
          phone2Ref={phone2InViewState.ref}
          phone3Ref={phone3InViewState.ref}
          phone1AnimateBool={phone1AnimateBool}
          phone2AnimateBool={phone2AnimateBool}
          phone3AnimateBool={phone3AnimateBool}
        />
      )}
    </div>
  );
};

export default WhatsNew;
